import { memo, splitProps } from '../helpers.js';
import { createRecipe, mergeRecipes } from './create-recipe.js';

const aromaMonthYearButtonFn = /* @__PURE__ */ createRecipe('aroma-month-year-button', {}, [])

const aromaMonthYearButtonVariantMap = {}

const aromaMonthYearButtonVariantKeys = Object.keys(aromaMonthYearButtonVariantMap)

export const aromaMonthYearButton = /* @__PURE__ */ Object.assign(memo(aromaMonthYearButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'aromaMonthYearButton',
  __getCompoundVariantCss__: aromaMonthYearButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: aromaMonthYearButtonVariantKeys,
  variantMap: aromaMonthYearButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, aromaMonthYearButtonVariantKeys)
  },
  getVariantProps: aromaMonthYearButtonFn.getVariantProps,
})